export default [
    
    // 客户端查看
    {
        path:  "reimbursement/index",
        name: "reimbursement",
        component: () => import(/* */ "@/views/reimbursement/index"),
    },
    {   //add 索赔单
        path: "reimbursement/update/:type",
        name: "reimbursementUpdate",
        component: () => import(/*  */ "@/views/reimbursement/update"),
    },
    // 管理端查看
    {
        path:  "reimbursement/adminIndex",
        name: "reimbursementAdmin",
        component: () => import(/* */ "@/views/reimbursement/adminIndex"),
    },
]